import { http } from "@/http/axios.js";

// 获取订单简要信息
export function getOrderInfoAPI(params) {
  return http({
    url: "/admin/order/info",
    method: "get",
    params,
  });
}

// 账单延期/挂账
export function compensateBillAPI(data) {
  return http({
    url: "/admin/finance/orderBill/compensate",
    method: "post",
    data,
  });
}

// 计算账单结清数据
export function calcSettlementAPI(data) {
  return http({
    url: "/admin/finance/orderBill/settlement/calc",
    method: "post",
    data,
  });
}

// 提交账单结清数据
export function submitSettlementAPI(data) {
  return http({
    url: "/admin/finance/orderBill/settlement/submit",
    method: "post",
    data,
  });
}

// 获取最近操作记录
export function getRecentActionListAPI(params) {
  return http({
    url: "/admin/finance/recentAction/list",
    method: "get",
    params,
  });
}
